import { CreateFolder } from '@/modules/fileManagement/types';
import uuid from 'uuid/v4';

export const createFolder = (conservatorship_id: string, folder_id: string = uuid()): CreateFolder => ({
  name: '',
  conservatorship_id,
  folder_id
});
